export default __webpack_public_path__ + "media/images/linkedin-social-97196b1614a4bce8718917207ddecc4b.svg";